import toast from 'components/partials/toast/toast';

interface ApiError {
  data?: {
    detail?: string;
    message?: string;
  };
  message?: string;
}

export const handleAidModelError = (
  error: unknown,
  title = 'Operation failed'
): void => {
  const apiError = error as ApiError;
  const message =
    apiError?.data?.detail ||
    apiError?.data?.message ||
    'An unexpected error occurred';

  toast.error({ title, message });
};
